module.exports = __webpack_public_path__ + "static/media/11.d6f9e433.jpg";